import styles from './DiamondCtaBadge.module.less';
import {DiamondIcon} from './DiamondIcon';
import Icon from '@/components/common/Icon';

interface DiamondCtaBadgeProps {
    /** CTA 简短文案，如 "开通" / "升级" */
    text: string;
    onClick?: () => void;
    className?: string;
}

/** 带 CTA 文案的钻石标签（皇冠 + 金色渐变背景 + 文案 + 箭头） */
export function DiamondCtaBadge({text, onClick, className}: DiamondCtaBadgeProps) {
    return (
        <span className={`${styles.badge} ${className || ''}`} onClick={onClick}>
            <span className={styles.iconWrapper}>
                <DiamondIcon size={16} />
            </span>
            <span className={styles.ctaArea}>
                <span className={styles.ctaText}>{text}</span>
                <Icon name="AijBasicYou1" size={10} className={styles.arrowIcon} />
            </span>
        </span>
    );
}
